import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';

import { Props } from '@/pages/Timeline/components/TimelineIcon/types';

const TimelineIcon = ({ className, icon }: Props) => {
  return (
    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-neutral-100 mr-2">
      <FontAwesomeIcon className={`text-2xl ${className || ''}`} icon={icon} />
    </div>
  );
};

export default memo(TimelineIcon);
